import { render, staticRenderFns } from "./NewPageDragHandles.vue?vue&type=template&id=1954e098&scoped=true&"
import script from "./NewPageDragHandles.vue?vue&type=script&lang=ts&"
export * from "./NewPageDragHandles.vue?vue&type=script&lang=ts&"
import style0 from "./NewPageDragHandles.vue?vue&type=style&index=0&id=1954e098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954e098",
  null
  
)

export default component.exports